module.exports = __webpack_public_path__ + "media/images/ticket/navi_coupon-94ffe046032c1c0291827880d10cb618.png";